import Analytics from '../../utils/Analytics';

export default {
  state: {
    data: {},
  },
  mutations: {
    'personal/setData'(store, payload) {
      try {
        store.data = {
          ...payload,
        };
      } catch (err) {
        console.error(err);
      }
    },
    'personal/setError'(store, payload) {
      try {
        store.data = {
          ...store.data,
          errors: {
            ...payload,
          },
        };
      } catch (err) {
        console.error(err);
      }
    },
    'personal/setReCapchaToken'(store, payload) {
      try {
        store.data = {
          ...store.data,
          // reCaptchaToken: payload,
        };
      } catch (err) {
        console.error(err);
      }
    },
  },
  actions: {
    async 'personal/getData'({ state, commit }, payload) {
      try {
        commit('global/loaderStart');
        const path = state.data.routes?.[payload.action]?.path;

        const { status, data } = await axios.post(path, payload);

        if (status !== 200) throw `Bad request response status: ${status}`;

        commit('personal/setData', data);
      } catch (err) {
        console.error(err);
      } finally {
        commit('global/loaderStop');
      }
    },
    async 'personal/signUpByPhone'({ state, commit }, formData) {
      try {
        const {
          path,
          data: { action, api },
        } = state.data?.routes?.send_sms_code;

        const phone = formData.get('USER_LOGIN')?.replace(/[+ ]/g, '');

        formData.set('action', action);
        formData.set('api', api);
        formData.set('authType', 'registration');
        formData.set('USER_LOGIN', phone);
        formData.set('phone_number', phone);

        const { status, data: responseData } = await axios.post(path, formData);

        if (status !== 200) throw `bad request response status: ${status}`;

        if (responseData.error) {
          commit('personal/setError', { signUpByPhone: responseData.error });
        } else {
          return responseData;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async 'personal/signInByPhone'({ state, commit }, formData) {
      const {
        path,
        data: { action, api },
      } = state.data?.routes?.send_sms_code;

      const phone = formData.get('phone');

      formData.set('action', action);
      formData.set('api', api);
      formData.set('authType', 'enter');
      formData.set('USER_LOGIN', phone);
      formData.set('phone_number', phone);

      const { status, data: responseData } = await axios.post(path, formData);

      if (status !== 200) throw `bad request response status: ${status}`;

      if (responseData.error) {
        commit('personal/setError', { signInByPhone: responseData.error });
      } else {
        return responseData;
      }
    },
    async 'personal/confirmPhone'({ state, commit }, formData) {
      try {
        const {
          path,
          data: { action, api },
        } = state.data.routes.sms_process_login;

        formData.set('action', action);
        formData.set('api', api);

        const { status, data } = await axios.post(path, formData);

        if (status !== 200) throw `bad request response status: ${status}`;

        if (data.error) {
          commit('personal/setError', { confirmPhone: data.error });
        } else if (data.isAuthorize) {
          if (data.user_email) {
            Analytics.signIn({
              user_phone: formData.get('phone'),
              user_email: data.user_email,
            });
            Analytics.updatedBasket();
          }

          location.reload();
        }
      } catch (err) {
        console.error(err);
      }
    },
    /**
     * new api
     * * */
    async 'personal/login_by_phone_and_password'({ state, commit }, formData) {
      // console.log(state.data?.routes?.login_by_phone_and_password);
      const {
        path,
        'params-example-data': { action },
      } = state.data?.routes?.login_by_phone_and_password;

      formData.set('action', action);

      const {
        status,
        data: { response: responseData },
      } = await axios.post(path, formData);

      if (responseData.status === false) {
        commit('personal/setError', { signInByPhoneAndPassword: responseData.text });
        return responseData;
      }
      return responseData;
    },

    // restore password by email
    async 'personal/sendPasswordRecoveryCheckWordToUserEmail'({ state, commit }, formData) {
      const {
        path,
        'params-example-data': { action },
      } = state.data?.routes?.sendPasswordRecoveryCheckWordToUserEmail;

      formData.set('action', action);

      const {
        status,
        data: { response: responseData },
      } = await axios.post(path, formData);
      // console.log(responseData, responseData.status === false);
      if (responseData.status === false) {
        // console.log('ERROR');
        commit('personal/setError', { forgetPasswordEmail: responseData.text });
      }
      return responseData;
    },

    async 'personal/doPasswordRecoveryByCheckWordAndEmail'({ state, commit }, formData) {
      const {
        path,
        'params-example-data': { action },
      } = state.data?.routes?.doPasswordRecoveryByCheckWordAndEmail;

      formData.set('action', action);

      const {
        status,
        data: { response: responseData },
      } = await axios.post(path, formData);
      // console.log(responseData, responseData.status === false);
      if (responseData.status === false) {
        // console.log('ERROR');
        commit('personal/setError', { forgetPasswordRecovery: responseData.text });
      }
      return responseData;
    },

    // registration global
    async 'personal/sendRegisterLinkToGlobalUser'({ state, commit }, formData) {
      const {
        path,
        'params-example-data': { action },
      } = state.data?.routes?.sendRegisterLinkToGlobalUser;

      formData.set('action', action);

      const {
        status,
        data: { response: responseData },
      } = await axios.post(path, formData);

      if (responseData.status === false) {
        commit('personal/setError', { registerSendLink: responseData.text });
      }
      return responseData;
    },
    // register Ukraine
    async 'personal/registerUkraine'({ state, commit }, formData) {
      const {
        path,
        data: { action },
      } = state.data?.routes?.register;

      formData.set('action', action);

      const {
        status,
        data: { response: responseData },
      } = await axios.post(path, formData);

      if (responseData?.status === false) {
        commit('personal/setError', { registerUkraine: responseData.text });
      }
      return responseData;
    },
  },
};
